import { ControlPanelMetric } from "../enums/BusinessLogic";
import { GHGEmissionsByPortfolio } from "../models/controlPanelDataModel";
import { MESSAGES } from "../messages";
import { ScopeFilter, Filter } from "../types/PageFilterTypes";
import { QueryFilterType } from "../types/ScreenerTypes";
import { MinMaxKey } from "../components/tables/NumericFilter";

export const SCOPE_FILTERS: ScopeFilter[] = [
  {
    key: ControlPanelMetric.SCOPE_1_WACI,
    displayValue: "Scope 1 WACI",
  },
  {
    key: ControlPanelMetric.SCOPE_1_2_WACI,
    displayValue: "Scope 1 & 2 WACI",
  },
  {
    key: ControlPanelMetric.SCOPE_1_2_3_WACI,
    displayValue: "Scope 1, 2 & 3 WACI",
  },
  {
    key: ControlPanelMetric.SCOPE_1_CV,
    displayValue: "Scope 1 CV",
  },
  {
    key: ControlPanelMetric.SCOPE_1_2_CV,
    displayValue: "Scope 1 & 2 CV",
  },
  {
    key: ControlPanelMetric.SCOPE_1_2_3_CV,
    displayValue: "Scope 1, 2 & 3 CV",
  },
];

export const DEFAULT_FILTER: Filter = {
  key: null,
  displayValue: MESSAGES.NO_FILTER_APPLIED,
};

export const DEFAULT_SCOPE_FILTER: ScopeFilter = {
  key: null,
  displayValue: "Select scope",
};

export const DEFAULT_FUND_FILTER: Filter = {
  key: null,
  displayValue: "Select fund",
};

export const DEFAULT_COMPANY_FILTER: Filter = {
  key: null,
  displayValue: "Select company",
};

export const DEFAULT_MANAGER_FILTER: Filter = {
  key: null,
  displayValue: "Select manager",
};

export const DEFAULT_LOADING_OPTIONS: Filter[] = [
  {
    key: "loading",
    displayValue: "Loading...",
    selectorName: "loading",
  },
];

export const createFundFilters = (
  ghgEmissionsData: GHGEmissionsByPortfolio[]
): Filter[] => {
  const funds = ghgEmissionsData.map((item) => item.portfolio_index_id);
  return funds.map((fund) => ({
    key: fund,
    displayValue: fund,
  }));
};

type AnyObject = { [key: string]: any }; // eslint-disable-line @typescript-eslint/no-explicit-any

export const updateFilter = <T extends AnyObject>(
  initialObject: T,
  keys: string[],
  value: AnyObject | string | number | boolean | null
): T => {
  let currentLevel: any = initialObject; // eslint-disable-line @typescript-eslint/no-explicit-any

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      // If it's the last key, set the value
      currentLevel[key] = value;
    } else {
      // Ensure the next level is an object or create it
      if (!currentLevel[key] || typeof currentLevel[key] !== "object") {
        currentLevel[key] = {};
      }
      currentLevel = currentLevel[key];
    }
  });

  return { ...initialObject };
};

export const formatMetricFilter = (
  input: Record<string, string[] | MinMaxKey>
): QueryFilterType[] =>
  Object.entries(input)
    .filter(([, value]) => value !== null)
    .map(([key, value]) => ({
      column_key: key,
      values: (Array.isArray(value) ? value.flat(Infinity) : [value]).filter(
        (v): v is string | number => v !== null
      ) as string[] | number[],
    }))
    .filter((item) => item.values.length > 0);
